import { isValidDate } from "@/common/utils/dateValidator";
import { formatDate } from "@/common/utils/formatters";
import { ContractualCycle } from "@/features/clientBills/types/clientBills.type";
import { weekDayLabels } from "../constants/weekDays.constants";
import { getDateDiffInDays } from "./date";

export const dateTransformer = (date: string) => {
  const [year, month, day] = date.split('-');
  return `${day}/${month}/${year}`;
};

export const dateIsoTransformer = (isoDate: string): string => {
  const [datePart] = isoDate.split(' ');
  return dateTransformer(datePart);
};

export const dateTimeTransformer = (date: Date) => {
  if (!isValidDate(date)) return '';

  const formattedDate = formatDate(date);
  const formattedMinutes = String(date.getMinutes()).padStart(2, '0');

  return `${formattedDate} - ${date.getHours()}:${formattedMinutes}`;
};

export const dateToISOStingTransformer = (date: Date | undefined) => {
  return date ? `${date.toISOString().split("T")[0]}` : "";
}

export const dateBrStringToISO = (date: string | null | undefined) => {
  if (!date) return null;

  const [day, month, year] = date.split('/');

  if (!day || !month || !year) {
    return null;
  }

  return `${year}-${month}-${day}`;
};

type FormatDatePeriodFriendlyNameProps = {
  closedAt: string;
  openedAt: string;
  contractualCycle?: ContractualCycle | null;
};

export const formatDatePeriodFriendlyName = (data?: FormatDatePeriodFriendlyNameProps): string => {
  if (!data?.openedAt || !data?.closedAt || !data?.contractualCycle) return '--';

  const openedAtDate = new Date(data.openedAt);
  const closedAtDate = new Date(data.closedAt);
  const openedAtDay = openedAtDate.getDate();
  const closedAtDay = closedAtDate.getDate();
  const cycle = data.contractualCycle;

  if (!isValidDate(openedAtDate) || !isValidDate(closedAtDate)) return '--';

  const strategies: Record<ContractualCycle, () => string> = {
    weekly: () => {
      const weekDay = weekDayLabels[openedAtDate.getUTCDay()]
      return weekDay ? `Semanal - ${weekDay}` : 'Semanal'
    },
    monthly: () => {
      const monthDay = String(openedAtDay).padStart(2, '0')
      return `Mensal - Dia ${monthDay}`
    },
    fixed: () => {
      const interval = getDateDiffInDays(openedAtDate, closedAtDate)
      return interval ? `Intervalo Fixo - ${interval} dias` : 'Intervalo Fixo'
    },
    fortnightly: () => {
      if(openedAtDay < 15 && closedAtDay <= 15) return '1ª Quinzena'

      if(openedAtDay >= 15 && closedAtDay > 15) return '2ª Quinzena'

      return 'Quinzenal'
    }
  }

  const formatPeriod = strategies[cycle]

  return formatPeriod ? formatPeriod() : '--'
};